module.exports = __webpack_public_path__ + "static/media/croisee.97858cf7.png";